export const ORGANIZATION_TYPE = {
  CLINIC: "clinic",
  ECOMMERCE: "ecommerce",
} as const;

export type OrganizationType =
  (typeof ORGANIZATION_TYPE)[keyof typeof ORGANIZATION_TYPE];

export type CreateOrganizationPayload = {
  name: string;
  phoneNumber: string;
  website?: string | null;
  currency?: string | null;
  type: OrganizationType;
  timezone?: string;
}

export type CreateOrganizationResponse = {
  name: string;
  createdAt: Date;
  updatedAt: Date;
}

export type Organization = {
  id: string;
  name: string;
  slug: string;
  createdAt: Date;
  updatedAt: Date;
  phoneNumber: string;
  website: string | null;
  currency: string | null;
  type: OrganizationType;
  timezone: string | null;
}

export type UpdateOrganizationPayload = Partial<CreateOrganizationPayload> & {
  id: string;
};
